/* global axios */
import ApiClient from './ApiClient';

/**
 * Agendamentos — o que a plataforma vai fazer sozinha, e quando.
 *
 * Lista unificada de duas fontes (timers de estágio do Kanban + retomadas do
 * motor de reengajamento da IA), já fundida pelo backend em
 * `ScheduledActions::Query`.
 */
class ScheduledActionsAPI extends ApiClient {
  constructor() {
    super('scheduled_actions', { accountScoped: true });
  }

  // `from`/`to` em epoch (s): o calendário pede só o período visível.
  list({ status = 'pending', from = null, to = null } = {}) {
    const params = { status };
    if (from) params.from = from;
    if (to) params.to = to;
    return axios.get(this.url, { params });
  }

  /**
   * O `id` é COMPOSTO e carrega dois-pontos ("stage_timer:12") porque a lista
   * mistura duas tabelas. Ele já vem pronto pra URL — passar por
   * `encodeURIComponent` viraria "stage_timer%3A12" e mudaria o caminho que o
   * contrato pede. O reflexo de escapar aqui é o erro fácil; o spec do módulo
   * Vuex prende a URL exata pra ele não voltar.
   */
  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }
}

export default new ScheduledActionsAPI();
